export const formatDate = (dateString) => {
    const [datePart, timePart] = dateString.split("T");
    const [year, month, day] = datePart.split("-");
    const [hour, minute, second] = timePart.slice(0, -1).split(":");
    const ampm = hour < 12 ? "AM" : "PM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${year}-${month}-${day} ${formattedHour}:${minute}:${second.slice(0, 2)} ${ampm}`;
};
